const scrollDistance = 1 // slow 3-5

export enum ScrollAction {
    Stop = 'STOP',
    ToTop = 'JUMP_TOP',
    ScrollTop = 'SCROLL_TOP',
    ScrollBottom = 'SCROLL_BOTTOM',
    Idle = 'IDLE'
}

export enum ScrollDirection {
    Up = 'UP',
    Down = 'DOWN'
}

export enum ScrollEvent {
    ReachedBottom = 'REACHED_BOTTOM',
    ReachedTop = 'REACHED_TOP'
}

export type EndOfScrollFunction = (d:ScrollDirection) => Promise<ScrollAction>

export type CancelFunction = () => void

export const useAutomaticPageScroll = (eosFunc:EndOfScrollFunction) => {
    const scrollBy = (offset:number, eosFunc:EndOfScrollFunction) : CancelFunction => {
        const direction = offset < 0 ? ScrollDirection.Up : ScrollDirection.Down

        let yStartOffset = window.scrollY

        const onScroll = (e:Event) => {
            e.preventDefault()
            // if reached top or bottom exit and call the eos func
            if ((window.innerHeight + window.scrollY >= document.body.scrollHeight && direction === ScrollDirection.Down)
                || (window.scrollY === 0 && direction === ScrollDirection.Up)) {
                clear()
                eosFunc(direction).then((a) => perform(a))
                return
            }

            if (window.scrollY-offset >= yStartOffset) {
                yStartOffset = window.scrollY
                window.scrollBy({
                    top: offset,
                    left: 0,
                    behavior: 'smooth'
                })
            }
        }

        const clear = () => {
            window.removeEventListener('scroll', onScroll)
        }

        window.addEventListener('scroll', onScroll)
        window.scrollBy({
            top: offset,
            left: 0,
            behavior: 'smooth'
        })
        return clear
    }

    const perform = (a: ScrollAction): CancelFunction => {
        if (a === ScrollAction.Idle) {
            return ():void =>{return}
        }
        let offset = scrollDistance
        if (a === ScrollAction.ScrollTop) {
            offset *= -1
        }
        return scrollBy(offset, eosFunc)
    }
    return perform
}

export const useScrollEvents = () => {
    return (cb: (e: ScrollEvent) => void):CancelFunction => {
        let prevScrollY = -1
        const onScroll = () => {
            if (prevScrollY < 0) {
                prevScrollY = window.scrollY
                return
            }
            let direction:ScrollDirection|undefined
            // scroll direction down
            if (window.scrollY-prevScrollY > 0) {
                direction = ScrollDirection.Down
            // scroll direction up
            } else if (window.scrollY-prevScrollY < 0) {
                direction = ScrollDirection.Up
            }
            // set it for the next time the event is fired
            prevScrollY = window.scrollY
            if (!direction) {
                return
            }
            if ((window.innerHeight + Math.ceil(window.scrollY)) >= document.body.scrollHeight && direction === ScrollDirection.Down) {
                cb(ScrollEvent.ReachedBottom)
                return
            }
            if (window.scrollY <= 0) {
                cb(ScrollEvent.ReachedTop)
                return
            }
        }
        window.addEventListener('scroll', onScroll)
        return () => {
            window.removeEventListener('scroll', onScroll)
        }
    }
}